export default __webpack_public_path__ + "static/media/LinearmotionImg.6e6de03d.jpg";